// extracted by mini-css-extract-plugin
export default {"container":"_30q7oNArs3Fc5EJ1z6yg1k","property":"_1mjcALwqVV5c-vu4EP6Z6Y","content":"_2nuG-mJ5gWw2ADf3UlNQLz","label":"uuVQhb1l86lTMNr0U0hPQ"};